import { UserRole } from '../model/common.model';

export const UserGroups = {
  Viewer: [UserRole.superadmin, UserRole.admin, UserRole.expert, UserRole.member1, UserRole.member2],
  UserActivity: [UserRole.superadmin],
  AudioDownload: [UserRole.superadmin, UserRole.admin, UserRole.expert],
  AudioPlay: [UserRole.superadmin, UserRole.admin, UserRole.expert, UserRole.member1],
};
